export const sexDictionary: { id: "M" | "F"; name: "Мужской" | "Женский" }[] = [
  {
    id: "M",
    name: "Мужской",
  },
  {
    id: "F",
    name: "Женский",
  },
];
